(function(angular){
	angular.module("skPlatformBootLoader", ["ng", "oc.lazyLoad", "ui.router", "ui.bootstrap","ngStorage", "ngSanitize", "ngUUID"]).config(
			["$httpProvider", "$stateProvider", "$locationProvider", "$urlRouterProvider",
			"$controllerProvider", "$compileProvider", "$provide", "$localStorageProvider",
			function($httpProvider, $stateProvider, $locationProvider, $urlRouterProvider, 
				$controllerProvider, $compileProvider, $provide, $localStorageProvider) {
				try {
					if($locationProvider && typeof $locationProvider.hashPrefix === "function"){
						$locationProvider.hashPrefix("");
					}
					var VMS_SERVICES = $localStorageProvider.get("VMS_SERVICES") || [];

					window["VMS_SERVICES"] = VMS_SERVICES;

					$httpProvider.interceptors.push("authHttpResponseInterceptor");

					//To disable IE cache GET calls globally
					if (!$httpProvider.defaults.headers.get) {
						$httpProvider.defaults.headers.get = {};
					}

					$httpProvider.defaults.headers.get["If-Modified-Since"] = "Mon, 1 Jan 1997 05:00:00 GMT";
					$httpProvider.defaults.headers.get["Cache-Control"] = "no-cache";
					$httpProvider.defaults.headers.get["Pragma"] = "no-cache";

					// We do not initially want an otherwise route check, that's handled in app.js,
					// so we rely on run to check if the Auth header we already have (if any) is valid first
					// and if it is, we go into the app.  If not, we go to /login
				} catch (e) {
					console["error"]("An error occurred in configuration of application bootloader.  The error was:", e);
				}
			}
		]).run(["$ocLazyLoad", function($ocLazyLoad){
		var loadApp;
		var checkCodecovEnv = function(){
			var n;
			try {
				n = navigator;
			} catch (ignore) {}					
			var codecov = false;
			if(n){
				var ua = n.userAgent || "";
				if(ua.indexOf("MSX_UT") == -1){
					codecov = false;
				}else{
					if(ua.indexOf("MSX_RUN_COVERAGE") == -1){
						codecov = false;
					}else{
						codecov = true;
					}
				}
			}else{
				codecov = false;
			}
			return codecov;
		};			
		if (checkCodecovEnv()) {
			loadApp = import(/* webpackChunkName: 'boot-coverage' */ 'boot-coverage'); // jshint ignore: line
		} else {
			loadApp = import(/* webpackChunkName: 'boot' */ 'boot'); // jshint ignore: line
		}
		loadApp.then(function() { // jshint ignore: line
			return $ocLazyLoad.load({name: 'skPlatformBoot'});
		});
	}]);
})(window.angular);